import { requireAuth } from "./utils/auth-guard.js";
import { Header, mountHeader, mountThemeToggle } from "@pinaroyalcargo/shared-ui";

const routes = [
  { path: "/login", page: () => import("./pages/login.page.js"), public: true },
  { path: "/reset-password", page: () => import("./pages/reset-password.page.js"), public: true },
  { path: "/", page: () => import("./pages/dashboard.page.js") },
  { path: "/shipments/new", page: () => import("./pages/new-shipment.page.js") },
  { path: /^\/shipments\/([^/]+)$/, page: () => import("./pages/shipment-detail.page.js") },
];

function renderShell(pageHtml, pathname) {
  return `${Header("admin", pathname)}<div class="bg-bg-subtle min-h-[calc(100vh-73px)] dark:bg-bg-subtle-dark">${pageHtml}</div>`;
}

export async function renderRoute(pathname, root) {
  for (const route of routes) {
    const match = typeof route.path === "string" ? pathname === route.path : route.path.exec(pathname);
    if (match) {
      if (!route.public && !requireAuth()) {
        window.history.pushState({}, "", "/login");
        renderRoute("/login", root);
        return;
      }
      
      const mod = await route.page();
      
      if (route.public) {
        root.innerHTML = mod.render(match[1]);
      } else {
        root.innerHTML = renderShell(mod.render(match[1]), pathname);
        mountHeader(root);
        mountThemeToggle(root);
        
        // Handle logout
        const logoutBtn = root.querySelector("#logout-button");
        if (logoutBtn) {
          logoutBtn.addEventListener("click", () => {
            localStorage.removeItem("token");
            window.history.pushState({}, "", "/login");
            renderRoute("/login", root);
          });
        }
      }
      
      mod.mount?.(root, match[1]);
      return;
    }
  }
  
  if (pathname !== "/login" && pathname !== "/reset-password") requireAuth();
  root.innerHTML = renderShell(`<main class="p-8"><h1>Page not found</h1></main>`, pathname);
  mountHeader(root);
  mountThemeToggle(root);
}

export function initRouter(root) {
  renderRoute(window.location.pathname, root);
  window.addEventListener("popstate", () => renderRoute(window.location.pathname, root));

  document.addEventListener("click", (e) => {
    const link = e.target.closest("a[data-link]");
    if (!link) return;
    e.preventDefault();
    const href = link.getAttribute("href");
    window.history.pushState({}, "", href);
    renderRoute(href, root);
  });
}
